import { en } from "./locales/en";
import { de } from "./locales/de";
import { ru } from "./locales/ru";
import { sl, type Translations } from "./locales/sl";
import { localeFromPath } from "./routes";
import type { Locale } from "./types";

export const translations: Record<Locale, Translations> = { sl, en, de, ru };

/**
 * Strings for a path, for the few places that render outside
 * `LocaleProvider` — the error boundary wraps the router itself, so it cannot
 * use `useLocale()` and has to read the locale off the URL.
 */
export function translationsForPath(pathname: string): Translations {
  return translations[localeFromPath(pathname)];
}
